import { axiosPrivate } from "@app/dashboard/tools/axios/axiosInstance"
import { AxiosRequestConfig } from "axios";

interface CustomAxiosRequestConfig extends AxiosRequestConfig {
    allow403?: boolean;
};

export const connectXeroOrganization = (apiKeys: string | null) => {
    return axiosPrivate.get(`/dashboard/api/v1/xero/authorize?api_key=${apiKeys}`, { allow403: true } as CustomAxiosRequestConfig)
}
